import { createSlice } from "@reduxjs/toolkit";

const DeletedAccount = createSlice({
  name: "deletedAccount",
  initialState: {
    deletedAccount: false,
    addClientIdAccount: false,
    updateUAStatus: false,
    updatedAccount: false,
    updateFieldStatus: false,
  },
  reducers: {
    changeDeletedAccountTrue: (state, action) => {
      state.deletedAccount = true;
    },
    changeDeletedAccountFalse: (state) => {
      state.deletedAccount = false;
    },
    changeUpdatedAccountTrue: (state, action) => {
      state.updatedAccount = true;
    },
    changeUpdatedAccountFalse: (state) => {
      state.updatedAccount = false;
    },
    AddClientIdAccountTrue: (state, action) => {
      state.addClientIdAccount = true;
    },
    AddClientIdAccountFalse: (state) => {
      state.addClientIdAccount = false;
    },
    UpdateUAStatusTrue: (state, action) => {
      state.updateUAStatus = true;
    },
    UpdateUAStatusFalse: (state) => {
      state.updateUAStatus = false;
    },
    UpdateFieldStatusTrue: (state, action) => {
      state.updateFieldStatus = true;
    },
    UpdateFieldStatusFalse: (state) => {
      state.updateFieldStatus = false;
    },
  },
});

export const {
  changeDeletedAccountTrue,
  changeDeletedAccountFalse,
  AddClientIdAccountTrue,
  AddClientIdAccountFalse,
  UpdateUAStatusTrue,
  UpdateUAStatusFalse,
  changeUpdatedAccountFalse,
  changeUpdatedAccountTrue,
  UpdateFieldStatusFalse,
  UpdateFieldStatusTrue,
} = DeletedAccount.actions;

export default DeletedAccount.reducer;
